import 'platform/platform.js';

export const platform = window['platform'];
export const isIEorEdge = platform.name === 'EDGE' || platform.name === 'IE';
export const isDesktopSafari = platform.os && platform.name === 'Safari' && platform.os.family === 'OS X';
